<template>
	<v-app>
		<v-overlay :value="drawer" z-index="4">
		</v-overlay>
		<v-navigation-drawer v-model="drawer" app clipped hide-overlay temporary
			:style="{ top: $vuetify.application.top + 'px', zIndex: 6 }" v-if="isNotLogin">
			<v-list dense>
				<v-list-item @click="navigateToHome">
					Selector de pantalla
				</v-list-item>
			</v-list>
		</v-navigation-drawer>

		<v-app-bar app clipped-left dark color="#447fa6" v-if="isNotLogin">
			<v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
			<v-toolbar-title>Ihabar Molino</v-toolbar-title>
		</v-app-bar>

		<v-main>
			<router-view @mandar-pagina="mandarPagina" @mandar-escritura="mandarEscritura"></router-view>
		</v-main>
	</v-app>
</template>

<script>
const MQTT_URL = process.env.VUE_APP_MQTT_URL;
const MQTT_PORT = process.env.VUE_APP_MQTT_PORT;

//import * as mqtt from 'mqtt/dist/mqtt.min'

import mqtt from 'mqtt';


export default {
	name: 'App',

	components: {
	},

	computed: {
		isNotLogin() {
			return this.$route.name !== 'login';
		}
	},

	data: () => ({
		drawer: false,
		client: null
	}),

	mounted() {
		this.connectMQTT();
	},

	methods: {
		navigateToHome() {
			this.$router.push('/').catch(err => {
				// ignora el error de navegación duplicada
				if (err.name !== 'NavigationDuplicated') {
					console.error(err);
				}
				this.drawer = false;
			});
		},
		connectMQTT() {
			const ruta = `${MQTT_URL}:${MQTT_PORT}`
			console.log(ruta)
			this.client = mqtt.connect(`${MQTT_URL}:${MQTT_PORT}`);
			console.log(this.client);

			this.client.on('error', (error) => {
				console.error('Error MQTT:', error);
			});

			this.client.on('close', () => {
				console.warn('Conexión MQTT cerrada');
			});

			this.client.on('connect', () => {
				console.log('Conectado a MQTT');
			});

			this.subscribeToTopic();
		},

		subscribeToTopic() {
			this.client.subscribe('lecturas', (err) => {
				if (err) {
					console.error('Error al suscribirse al topic:', err);
				} else {
					// console.log('Suscrito exitosamente al topic "lecturas"');
				}
			});

			this.client.on('message', (topic, message) => {
				// message es un Buffer, convertirlo a string
				const msg = JSON.parse(message.toString());
				// console.log(msg)

				this.$store.state.lecturas = msg.palabras;
				// console.log(this.$store.state.lecturas)
			});
		},

		mandarPagina(topic, pagina, maquina) {
			if (this.client != null) {

				let payload = ''
				if (maquina != '') {
					payload = 'p' + pagina + 'm' + maquina;
				}
				else {
					payload = 'p' + pagina;
				}
				// Convierte el payload a una cadena JSON
				const payloadString = JSON.stringify(payload);

				// Publica el payload en un topic específico
				this.client.publish(topic, payloadString, (err) => {
					if (err) {
						console.error('Error al publicar mensaje:', err);
					} else {
						// console.log('Mensaje publicado exitosamente');
					}
				});
			}
		},

		mandarEscritura(payload) {
			// Convierte el payload a una cadena JSON
			const payloadString = JSON.stringify(payload);

			// Publica el payload en un topic específico
			this.client.publish('escritura', payloadString, (err) => {
				if (err) {
					console.error('Error al publicar mensaje:', err);
				} else {
					console.log('Mensaje publicado exitosamente');
				}
			});
		}
	}
};
</script>

<style></style>
